import { createContext, useContext } from 'react'

import type { SectionsHeroComponent } from '@twisto/api-cms'

const HeroContext = createContext<SectionsHeroComponent | undefined>(undefined)

export const HeroProvider = ({
  children,
  value,
}: {
  children: React.ReactNode
  value: SectionsHeroComponent
}) => <HeroContext.Provider value={value}>{children}</HeroContext.Provider>

export const useHeroContext = () => {
  const ctx = useContext(HeroContext)

  if (!ctx) {
    throw new Error('useHeroContext must be used inside HeroProvider')
  }

  return ctx
}
